import type { FC, ReactNode } from 'react'

import './page.scss'

const Page: FC<{ children: ReactNode; className?: string }> = ({
  children,
  className = '',
  ...restOfProps
}) => (
  <div className={`page ${className}`} {...restOfProps}>
    {children}
  </div>
)

export default Page
